"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getSchools = function () {
    return (0, service_1.getService)()
        .get('/schools')
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getSchools;
